export const routes = (prefix=`medical-file-view`) => [
    {
        name: `${prefix}.index`,
        path: `/${prefix}/:patientID`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.index`,
                PageDescription: "Medical File: Patient Medical History",
            },
        },
    },
];
